import { ReportColumnPersonalizationFlags } from '../columnUtils.types';
import {
  CostOfGoodsSoldReportTableGroupingColumnId,
  CostOfGoodsSoldReportTableValueColumnId,
} from './costOfGoodsSoldColumnUtils.types';

export const COST_OF_GOODS_SOLD_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [CostOfGoodsSoldReportTableGroupingColumnId.AuditDateTime]: {
    isDateTime: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.UnitCostChangeInCurrentCurrency]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.PreviousUnitCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.UnitCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.PreviousTotalCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.TotalCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.TotalCostChangeInCurrentCurrency]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.PreviousNumberOfTickets]: {
    isNumeric: true,
    isInteger: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.NumberOfTickets]: {
    isNumeric: true,
    isInteger: true,
  },
  [CostOfGoodsSoldReportTableValueColumnId.NumberOfTicketsChange]: {
    isNumeric: true,
    isInteger: true,
  },
};
